import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.settingData.loading;
export const selectErrorMessage = (state: RootState) => state.settingData.error;
export const settingDataResponse = (state: RootState) =>
  state.settingData.settingDataResponse;
